/* eslint-disable */
import { noop } from 'lodash';
import { fm } from '../vendor/liveswitch/src';

import { lsLog, lsErrorLog } from './shared/utils/logger';

const wait = (ttl) => new Promise((rslv) => setTimeout(rslv, ttl));
const VIDEO_WIDTH = 1024;
const VIDEO_HEIGHT = 768;
const VIDEO_FPS = 25;

const ICE_SERVERS = [
];

window.liveswitchVersion = () => console.log(
  '---',
  'fm.liveswitch.Build.getVersion() is',
  fm.liveswitch.Build.getVersion(),
  '---',
);
window.liveswitchVersion();

class VideoProvider {
  constructor(options) {
    this.options = options;
    this.localMediaObject = null;
    this.remoteMediaObject = null;
    this.layoutManager = null;
    this.channel = null;
    this.jwtToken = null;
    this.isTeardown = false;
    this.isMCU = options.isMCU;
    this.isOffline = false;
    this.clientRoles = options.clientRoles;
    this.volume = options.volume;
    this.name = options.name;
    this.mediaMuted = {
      getIsVideoMuted: this.options.getIsVideoMuted,
      getIsAudioMuted: this.options.getIsAudioMuted,
    };
    this.connections = {
      pending: {},
      downstream: {},
      upstream: null,
    };

    this.client = new fm.liveswitch.Client(
      this.options.gatewayUrl,
      this.options.applicationId,
      this.options.userId,
      this.options.deviceId,
      this.options.clientId,
      this.clientRoles,
      'Public',
    );
    this.client.setUserAlias(this.name);


    const {
      observeOnMessage = noop,
      observeOnStateChange = noop,
      onMcuVideoLayoutChange = noop,
      observeOnRemoteClientJoin = noop,
      observeOnRemoteClientLeave = noop,
      observeOnUpstreamStateChange = noop,
      observeOnDownstreamStateChange = noop,
      observeOnRemoteUpstreamConnectionOpen = noop,
      observeOnRemoteUpstreamConnectionClose = noop,
    } = this.options.observeCallbacks;

    this.observeOnMessage = observeOnMessage;
    this.observeOnStateChange = observeOnStateChange;
    this.onMcuVideoLayoutChange = onMcuVideoLayoutChange;
    this.observeOnRemoteClientJoin = observeOnRemoteClientJoin;
    this.observeOnRemoteClientLeave = observeOnRemoteClientLeave;
    this.observeOnUpstreamStateChange = observeOnUpstreamStateChange;
    this.observeOnDownstreamStateChange = observeOnDownstreamStateChange;
    this.observeOnRemoteUpstreamConnectionOpen = observeOnRemoteUpstreamConnectionOpen;
    this.observeOnRemoteUpstreamConnectionClose = observeOnRemoteUpstreamConnectionClose;
  }

  register(jwtToken) {

    if (this.isOffline) {
      this.isOffline = false;
      return;
    }

    this.isTeardown = false;
    this.jwtToken = jwtToken;
    this._closeDownstreamConnections();

    const stateChange = (c) => {
      this.observeOnStateChange(c);
      lsLog(`CHANNEL CONNECTION state is
        ${ fm.liveswitch.ClientState[c.getState()].toUpperCase() }`, { 'c.getState()': c.getState() });

      switch (c.getState()) {
        case fm.liveswitch.ClientState.Registering:
        case fm.liveswitch.ClientState.Registered:
        case fm.liveswitch.ClientState.Unregistering:
          break;

        case fm.liveswitch.ClientState.Unregistered:
          if (!this.isTeardown) {
            this.client.removeOnStateChange(stateChange);
            return wait(2500)
              .then(() => this.register(this.jwtToken));
          }
          break;

        default:
          break;
      }
    };

    this.client.addOnStateChange(stateChange);

    return this
      .client
      .register(this.jwtToken)
      .then(([channel]) => {
        this.channel = channel;
        this._closeConnections();

        lsLog(`ME $register channel:`, channel);
        lsLog(`ME $register client.id: ${ this.client.getId() }`);
        lsLog(`ME $register client.userId: ${ this.client.getUserId() }`);
        lsLog(`ME $register client.deviceId: ${ this.client.getDeviceId() }`);

        this.channel.addOnMcuVideoLayout(data => {
          let participantsCount = 0;
          data._regions.map((remoteClient) => {
            if (remoteClient._clientRoles[0] === 'participant') participantsCount++;
          });

          return this.onMcuVideoLayoutChange(participantsCount);
        });

        this.channel.addOnMessage((client, message) => {
          const isMe = (client.getUserId() === channel.getUserId());
          lsLog(`$observeOnMessage isMe ${ isMe }`, { client, message });

          if (isMe) return;

          let payload = message;
          try {
            payload = JSON.parse(message);
          } catch (e) {
            lsErrorLog('$observeOnMessage not a json', message);
          }

          this.observeOnMessage(client, payload);
        });

        this.channel.addOnRemoteClientJoin(remote => {
          this.toggleAudioMute(this.mediaMuted.getIsAudioMuted());
          this.toggleVideoMute(this.mediaMuted.getIsVideoMuted());
          lsLog(
            '$observeOnRemoteClientJoin',
            { remote, 'isMe': remote.getUserId() === channel.getUserId() },
          );
          if (remote.getUserId() !== channel.getUserId()) {
            this.observeOnRemoteClientJoin(remote);
          }
        });

        this.channel.addOnRemoteClientLeave(remote => {
          lsLog(
            '$observeOnRemoteClientLeave',
            { remote, 'isMe': remote.getUserId() === channel.getUserId() },
          );
          this.observeOnRemoteClientLeave(remote);
        });

        this.channel.addOnRemoteUpstreamConnectionOpen(remote => {
          const isMe = (remote.getUserId() === channel.getUserId());
          lsLog(
            'observeOnRemoteUpstreamConnectionOpen',
            { remote, 'isMe': isMe },
          );
          if (!isMe) {
            this.observeOnRemoteUpstreamConnectionOpen(remote);
            if(!this.isMCU) {
              this._downstreamConnection(remote);
            }
          }
        });

        this.channel.addOnRemoteUpstreamConnectionClose(remote => {
          lsLog(
            '$observeOnRemoteUpstreamConnectionClose',
            { remote, 'isMe': remote.getUserId() === channel.getUserId() },
          );
          this.observeOnRemoteUpstreamConnectionClose(remote);
        });

        // ONLY FOR sfuUpstreamConnection
        if(!this.isMCU) {
          setTimeout(() => this._upstreamConnection(), 100);
        }
        if(this.isMCU) {
          this._downstreamMCUConnection();
        }


        return channel;
      });
  }

  _closeDownstreamConnections() {
    Object.values(this.connections.downstream).forEach(c => c && c.close());
    this.connections.downstream = [];
  }

  _closeConnections() {
    if (this.connections.upstream) {
      this.connections.upstream.close();
      delete this.connections.upstream;
    }

    Object.values(this.connections.downstream).forEach(c => c && c.close());

    this.connections = {
      pending: {},
      upstream: null,
      downstream: [],
    };
  }

  release() {
    this.isTeardown = true;
    return this.stopMedia()
      .then(() => this.client.unregister())
      .then(() => {
        this._closeConnections();
        this.channel = null;
      });
  }

  _upstreamConnection() {
    return this
      ._getLocalMedia()
      .then(lm => {
        const videoStream = new fm.liveswitch.VideoStream(lm);
        videoStream.setSimulcastMode(fm.liveswitch.SimulcastMode.RtpStreamId);
        const connection = this.channel.createSfuUpstreamConnection(
          new fm.liveswitch.AudioStream(lm),
          videoStream,
        );
        this.connections.upstream = connection;

        connection.addOnAutomaticIceServers((conn, iceServers) => {
          const values = iceServers.getValues();
          for (var i = 0; i < values.length; i++) {
            const iceServer = values[i];
            if (iceServer.getIsStun()) {
              fm.liveswitch.Log.info("Removing ice server: " + iceServer.getUrl());
              iceServers.remove(iceServer);
            }
          }
        });

        connection.setTag(`sfu-up:${ this.client.getUserId() }`);
        connection.setIceServers(ICE_SERVERS);

        connection.addOnStateChange(c => {
          lsLog(
            `>>> UPSTREAM Connection state is  ${ c.getState() }`,
            {
              'fm.liveswitch.ConnectionState[c.getState()].toUpperCase()': fm.liveswitch.ConnectionState[c.getState()].toUpperCase(),
              'tag': c.getTag(),
              'channelId': c.getChannelId(),
              'Id': c.getId(),
            },
          );
          this.observeOnUpstreamStateChange(c);

          switch (c.getState()) {
            // Cleanup if the connection closes or fails.
            case fm.liveswitch.ConnectionState.Closing:
            case fm.liveswitch.ConnectionState.Failing:
              if (c.getRemoteClosed()) {
                this.connections.upstream = null;
              }

              break;
            case fm.liveswitch.ConnectionState.Closed:
              if (c.getRemoteClosed()) {
                this.connections.upstream = null;
              }
              break;

            case fm.liveswitch.ConnectionState.Failed:
              // TODO: We should remove event handlers to prevent ghosts!!
              return !this.isTeardown ? this._upstreamConnection() : null;

            default:
              // Do nothing
              break;
          }
        });

        connection.open()
          .then(() => {
            this.toggleAudioMute(this.mediaMuted.getIsAudioMuted());
            this.toggleVideoMute(this.mediaMuted.getIsVideoMuted());
            this.setVolumeLevel(this.volume);
            lsLog('>>> UPSTREAM CONNECTION ESTABLISHED');
          });

        return connection;
      });
  }


  _downstreamConnection(remote) {
    this._closeDownstreamConnections();

    console.log('[VIDEO_PROVIDER] << OPEN DOWNSTREAM CONNECTION', remote);
    const remoteMedia = new fm.liveswitch.RemoteMedia();
    // remoteMedia.setAudioMuted(false);
    // remoteMedia.setVideoMuted(false);
    // Add the remote video view to the layout.
    this.remoteMediaObject = remoteMedia;

    const connection = this.channel.createSfuDownstreamConnection(
      remote,
      new fm.liveswitch.AudioStream(null, remoteMedia),
      new fm.liveswitch.VideoStream(null, remoteMedia),
    );


    this.connections.downstream[connection.getId()] = connection;

    connection.addOnAutomaticIceServers((conn, iceServers) => {
      const values = iceServers.getValues();
      for (var i = 0; i < values.length; i++) {
        const iceServer = values[i];
        if (iceServer.getIsStun()) {
          fm.liveswitch.Log.info("Removing ice server: " + iceServer.getUrl());
          iceServers.remove(iceServer);
        }
      }
    });

    connection.setTag(`sfu-down:${ this.client.getUserId() }`);
    connection.setIceServers(ICE_SERVERS);

    connection.addOnStateChange(c => {
      console.warn(
        '[VIDEO_PROVIDER] << DOWNSTREAM Connection state is ', c.getState(),
        fm.liveswitch.ConnectionState[c.getState()].toUpperCase(),
        'tag:', c.getTag(),
        'channelId:', c.getChannelId(),
        'Id:', c.getId(),
      );

      this.observeOnDownstreamStateChange(c);
      switch (c.getState()) {
        // Cleanup if the connection closes or fails.
        case fm.liveswitch.ConnectionState.Closing:
        case fm.liveswitch.ConnectionState.Failing:
          // this.layoutManager.removeRemoteView(this.remoteMedia.getId());
          if (this.remoteMediaObject) {
            this.remoteMediaObject.destroy();
            this.remoteMediaObject = null;
          }
          break;
        // if (c.getRemoteClosed()) { }
        case fm.liveswitch.ConnectionState.Closed:
          this.connections.downstream[connection.getId()] = null;
          delete this.connections.downstream[connection.getId()];
          break;

        case fm.liveswitch.ConnectionState.Failed:
          return !this.isTeardown ? this._downstreamConnection(remote) : null;

        default:
          // Do nothing
          break;
      }
    });

    connection.open()
      .then(() => console.log('[VIDEO_PROVIDER] << DOWNSTREAM CONNECTION ESTABLISHED'));

    return connection;
  }

  _downstreamMCUConnection(remote) {
    // this._closeDownstreamConnections();
    if (this.remoteMediaObject) return;
    return this
      ._getLocalMedia()
      .then(lm => {
        lsLog('<<< OPEN DOWNSTREAM CONNECTION ', { remote });
        const remoteMedia = new fm.liveswitch.RemoteMedia();
        this.remoteMediaObject = remoteMedia;

        // const connection = this.channel.createSfuDownstreamConnection(
        //   remote,
        //   new fm.liveswitch.AudioStream(null, remoteMedia),
        //   new fm.liveswitch.VideoStream(null, remoteMedia),
        // );
        // new fm.liveswitch.AudioStream(lm),
        //   new fm.liveswitch.VideoStream(lm),
        const audioStream = new fm.liveswitch.AudioStream(lm, remoteMedia);
        const videoStream = new fm.liveswitch.VideoStream(lm, remoteMedia);
        const connection = this.channel.createMcuConnection(audioStream, videoStream);


        this.connections.downstream[connection.getId()] = connection;

        connection.setTag(`sfu-down:${ this.client.getUserId() }`);
        connection.setIceServers(ICE_SERVERS);

        connection.addOnStateChange(c => {
          lsLog(
            `<<< DOWNSTREAM Connection state is ${ c.getState() }`,
            {
              'fm.liveswitch.ConnectionState[c.getState()].toUpperCase()': fm.liveswitch.ConnectionState[c.getState()].toUpperCase(),
              'tag': c.getTag(),
              'channelId': c.getChannelId(),
              'Id': c.getId(),
            },
          );

          this.observeOnDownstreamStateChange(c);
          this.observeOnUpstreamStateChange(c);
          switch (c.getState()) {
            // Cleanup if the connection closes or fails.
            case fm.liveswitch.ConnectionState.Closing:
            case fm.liveswitch.ConnectionState.Failing:
              // this.layoutManager.removeRemoteView(this.remoteMedia.getId());
              // @todo check this
              if (this.remoteMediaObject) {
                this.remoteMediaObject.destroy();
                this.remoteMediaObject = null;
              }
              break;
            // if (c.getRemoteClosed()) { }
            case fm.liveswitch.ConnectionState.Closed:
              this.connections.downstream[connection.getId()] = null;
              delete this.connections.downstream[connection.getId()];
              break;

            case fm.liveswitch.ConnectionState.Failed:
              return !this.isTeardown ? this._downstreamConnection(remote) : null;

            default:
              // Do nothing
              break;
          }
        });

        connection.open()
          .then(() => {
            this.toggleAudioMute(this.mediaMuted.getIsAudioMuted());
            this.toggleVideoMute(this.mediaMuted.getIsVideoMuted());
            this.setVolumeLevel(this.volume);
            return lsLog('<<< DOWNSTREAM CONNECTION ESTABLISHED');
          });

        return connection;
      });
  }

  handleOffline() {
    this.isTeardown = true;
    this.isOffline = true;
    return this
      .stopMedia()
      .then(() => {
        this.remoteMediaObject && this.remoteMediaObject.destroy();
        this.remoteMediaObject = null;

        this._closeConnections();
        this.channel = null;
      });
  }

  handleOnline() {
    return this
      .client
      .unregister()
      .then(() => this.startMedia())
      .then(() => this.register(this.jwtToken));

  }

  _getLocalMedia() {
    if (!this.localMediaObject) {
      const videoConfig = new fm.liveswitch.VideoConfig(VIDEO_WIDTH, VIDEO_HEIGHT, VIDEO_FPS);
      this.localMediaObject = new fm.liveswitch.LocalMedia(true, true, null);
    }

    return Promise.resolve(this.localMediaObject);
  }

  startMedia() {
    return this
      ._getLocalMedia()
      .then(lm => lm.start());
  }

  stopMedia() {
    return this
      ._getLocalMedia()
      .then(localMedia => {
        localMedia.stop();
        return localMedia.destroy();
      });
  }


  getRemoteMediaStream() {
    return Promise.resolve(
      this.remoteMediaObject ? this.remoteMediaObject._getInternal()._videoMediaStream : null);
  }

  toggleAudioMute(makeMute) {
    return this
      ._getLocalMedia()
      .then(lm => {
        const audio = lm.getAudioTrack();
        if (!audio) {
          return false;
        }

        if (makeMute !== undefined) {
          audio.setMuted(!!makeMute);
        } else {
          audio.setMuted(!audio.getMuted());
        }
        const audioDisabled = audio.getMuted();
        this.broadcast({ audioDisabled });

        return audioDisabled;
      });
  }

  toggleVideoMute(makeMute) {
    return this
      ._getLocalMedia()
      .then(lm => {
        const video = lm.getVideoTrack();
        if (!video) {
          return false;
        }

        if (makeMute !== undefined) {
          video.setMuted(!!makeMute);
        } else {
          video.setMuted(!video.getMuted());
        }
        const videoDisabled = video.getMuted();
        this.broadcast({ videoDisabled });

        return videoDisabled;
      });
  }

  setVolumeLevel(value) {
    if (!this.remoteMediaObject) {
      return;
    }

    if (value === 0) {
      return this.remoteMediaObject.setAudioMuted(true);
    }

    if (this.remoteMediaObject.getAudioMuted() && value > 0) {
      this.remoteMediaObject.setAudioMuted(false);
    }

    this.remoteMediaObject.setAudioGain(value);
  }

  broadcast(payload) {
    return Promise.resolve(
      this.channel && this.channel.sendMessage(JSON.stringify(payload)),
    );
  }

}

/* eslint-enable */

export default VideoProvider;
